export enum DealsGridColumnId {
  // Deal fields
  DEAL_CREATED_DUE_TO_SERVICING_TYPE = 'DEAL_CREATED_DUE_TO_SERVICING_TYPE',
  DEAL_COMMITTED_SERVICING_TYPE = 'DEAL_COMMITTED_SERVICING_TYPE',
  DEAL_STATUS = 'DEAL_STATUS',
  DEAL_DIRECTION = 'DEAL_DIRECTION',
  DEAL_NOTIONAL = 'DEAL_NOTIONAL',
  DEAL_REPO_TYPE = 'DEAL_REPO_TYPE',
  DEAL_STOCK_BORROWING_LENDING_TYPE = 'DEAL_STOCK_BORROWING_LENDING_TYPE',
  DEAL_RATE = 'DEAL_RATE',
  DEAL_FEE = 'DEAL_FEE',
  DEAL_CLEAN_PRICE = 'DEAL_CLEAN_PRICE',
  DEAL_INDEX_RATIO = 'DEAL_INDEX_RATIO',
  DEAL_HAIRCUT = 'DEAL_HAIRCUT',
  DEAL_HAIRCUT_TYPE = 'DEAL_HAIRCUT_TYPE',
  DEAL_TERM = 'DEAL_TERM',
  DEAL_START_DATE = 'DEAL_START_DATE',
  DEAL_END_DATE = 'DEAL_END_DATE',
  DEAL_START_CONSIDERATION = 'DEAL_START_CONSIDERATION',
  DEAL_START_CONSIDERATION_OVERRIDE = 'DEAL_START_CONSIDERATION_OVERRIDE',
  DEAL_REPO_INTEREST = 'DEAL_REPO_INTEREST',
  DEAL_REPO_INTEREST_START_DATE = 'DEAL_REPO_INTEREST_START_DATE',
  DEAL_ACCUMULATED_REPO_INTEREST = 'DEAL_ACCUMULATED_REPO_INTEREST',
  DEAL_END_CONSIDERATION = 'DEAL_END_CONSIDERATION',
  DEAL_FUND_ID = 'DEAL_FUND_ID',
  DEAL_COUNTERPARTY_ID = 'DEAL_COUNTERPARTY_ID',
  DEAL_SETTLEMENT_VENUE = 'DEAL_SETTLEMENT_VENUE',
  DEAL_CSD = 'DEAL_CSD',
  DEAL_BOND_PRICE = 'DEAL_BOND_PRICE',
  DEAL_ALL_IN_PRICE = 'DEAL_ALL_IN_PRICE',
  DEAL_ACCRUED_INTEREST = 'DEAL_ACCRUED_INTEREST',
  DEAL_CALLABLE = 'DEAL_CALLABLE',
  DEAL_CALL_DAYS = 'DEAL_CALL_DAYS',
  DEAL_AXE_ROLL_UNWIND = 'DEAL_AXE_ROLL_UNWIND',
  DEAL_STRATEGY_ID = 'DEAL_STRATEGY_ID',
  DEAL_BOOK_ID = 'DEAL_BOOK_ID',
  DEAL_MARKET = 'DEAL_MARKET',
  DEAL_ID = 'DEAL_ID',
  DEAL_AXE_ID = 'DEAL_AXE_ID',
  DEAL_ORDER_ID = 'DEAL_ORDER_ID',
  DEAL_NEGOTIATION_ID = 'DEAL_RFQ_ID',
  DEAL_UTI = 'DEAL_UTI',
  DEAL_MIC = 'DEAL_MIC',
  DEAL_INITIATOR_UTI = 'DEAL_INITIATOR_UTI',
  DEAL_RESPONDER_UTI = 'DEAL_RESPONDER_UTI',
  DEAL_ORIGINATOR = 'DEAL_ORIGINATOR',
  DEAL_RFQ_CREATED_AT_DATE = 'DEAL_RFQ_CREATED_AT_DATE',
  DEAL_RFQ_CREATED_AT_TIME = 'DEAL_RFQ_CREATED_AT_TIME',
  DEAL_TRADE_DATE = 'DEAL_TRADE_DATE',
  DEAL_TRADE_TIME = 'DEAL_TRADE_TIME',
  DEAL_UPDATED_AT_DATE = 'DEAL_UPDATED_AT_DATE',
  DEAL_UPDATED_AT_TIME = 'DEAL_UPDATED_AT_TIME',
  DEAL_UPDATED_BY = 'DEAL_UPDATED_BY',
  DEAL_INVESTMENT_DECISION_MAKER = 'DEAL_INVESTMENT_DECISION_MAKER',
  DEAL_EXECUTION_DECISION_MAKER = 'DEAL_EXECUTION_DECISION_MAKER',
  DEAL_TRADE_TYPE = 'DEAL_TRADE_TYPE',
  DEAL_NOTICE_PERIOD_DAYS = 'DEAL_NOTICE_PERIOD_DAYS',
  PARENT_DEAL_ID = 'PARENT_DEAL_ID',
  CHILD_DEAL_ID = 'CHILD_DEAL_ID',
  ORIGINAL_DEAL_ID = 'ORIGINAL_DEAL_ID',
  DEAL_PRE_AGREED = 'DEAL_PRE_AGREED',
  DEAL_MASTER_LEGAL_AGREEMENT = 'DEAL_MASTER_LEGAL_AGREEMENT',
  MY_ENTITY_SHORT_NAME = 'MY_ENTITY_SHORT_NAME',
  MY_FICC_ENTITY_SHORT_NAME = 'MY_FICC_ENTITY_SHORT_NAME',
  EVERGREEN_NOTICE_PERIOD = 'EVERGREEN_NOTICE_PERIOD',
  ISSUE = 'ISSUE',
  MARKET_TRADE_DATE = 'MARKET_TRADE_DATE',
  SUBMITTING_USER = 'SUBMITTING_USER',

  // Collateral fields
  COLLATERAL_ISIN_OR_BUI = 'COLLATERAL_ISIN_OR_BUI',
  COLLATERAL_NAME = 'COLLATERAL_NAME',
  COLLATERAL_BASKET_NAME = 'COLLATERAL_BASKET_NAME',
  SECONDARY_COLLATERAL_NAME = 'SECONDARY_COLLATERAL_NAME',
  COLLATERAL_CURRENCY = 'COLLATERAL_CURRENCY',
  COLLATERAL_CUSIP = 'COLLATERAL_CUSIP',
  COLLATERAL_COUPON = 'COLLATERAL_COUPON',
  COLLATERAL_ISSUER = 'COLLATERAL_ISSUER',
  PRODUCT = 'PRODUCT',
  PRODUCT_SECTOR = 'PRODUCT_SECTOR',

  // Counterparty fields
  COUNTERPARTY_NAME = 'COUNTERPARTY_NAME',
  COUNTERPARTY_LEI = 'COUNTERPARTY_LEI',
  COUNTERPARTY_BIC = 'COUNTERPARTY_BIC',
  COUNTERPARTY_FIRM = 'COUNTERPARTY_FIRM',
  COUNTERPARTY_FIRM_LEI = 'COUNTERPARTY_FIRM_LEI',
  COUNTERPARTY_TRADER = 'COUNTERPARTY_TRADER',

  // Deal Interest Period fields
  DEAL_INTEREST_PERIOD_REPO_INTEREST_START_DATE = 'REPO_INTEREST_START_DATE',
  DEAL_INTEREST_PERIOD_REPO_INTEREST_END_DATE = 'REPO_INTEREST_END_DATE',
  DEAL_INTEREST_PERIOD_REPO_INTEREST_IN_PERIOD = 'REPO_INTEREST_IN_PERIOD',
  DEAL_INTEREST_PERIOD_REPO_INTEREST_TO_DATE = 'REPO_INTEREST_TO_DATE',
  DEAL_INTEREST_PERIOD_REPO_INTEREST_RATE = 'REPO_INTEREST_RATE',

  // Block fields
  BLOCK_TRADE = 'BLOCK_TRADE',
  BLOCK_DEAL_ID = 'BLOCK_DEAL_ID',

  // Fund fields
  FUND_NAME = 'FUND_NAME',
  FUND_LEI = 'FUND_LEI',
  FUND_BIC = 'FUND_BIC',
  FUND_FIRM = 'FUND_FIRM',
  FUND_FIRM_LEI = 'FUND_FIRM_LEI',
  TRADER = 'TRADER',

  // Misc fields
  FACTOR = 'FACTOR',
  ASSET_TYPE = 'ASSET_TYPE',
  BOOK_NAME = 'BOOK_NAME',
  REFERENCE_RATE_NAME = 'REFERENCE_RATE_NAME',
  FLOAT_CRYSTALLISATION_DAYS = 'FLOAT_CRYSTALLISATION_DAYS',
  STRATEGY_NAME = 'STRATEGY_NAME',
  PRIME_BROKER = 'PRIME_BROKER',
  BUNDLE_NAME = 'BUNDLE_NAME',
  NOTES = 'NOTES',

  // Sales coverage fields
  PRIMARY_COVER_USER = 'PRIMARY_COVER_USER',
  SECONDARY_COVER_USER = 'SECONDARY_COVER_USER'
}

export const DealFieldNames = {
  DEAL_STATUS: 'deal.status',
  DEAL_COLLATERAL_ISIN: 'deal.collateralId',
  DEAL_SECONDARY_COLLATERAL: 'deal.secondaryBasketId',
  DEAL_STOCK_BORROW_LENDING_TYPE: 'deal.stockBorrowingLendingType',
  DEAL_DIRECTION: 'deal.direction',
  DEAL_NOTIONAL: 'deal.notional',
  DEAL_REPO_TYPE: 'deal.repoType',
  DEAL_RATE: 'deal.rate',
  DEAL_FEE: 'deal.fee',
  DEAL_HAIRCUT: 'deal.haircut',
  DEAL_HAIRCUT_TYPE: 'deal.haircutType',
  DEAL_TERM: 'deal.term',
  DEAL_START_DATE: 'deal.startDate',
  DEAL_END_DATE: 'deal.endDate',
  DEAL_START_CONSIDERATION: 'deal.startConsideration',
  DEAL_START_CONSIDERATION_OVERRIDE: 'deal.startConsiderationOverride',
  DEAL_END_CONSIDERATION: 'deal.endConsideration',
  DEAL_FUND_ID: 'deal.fundId',
  DEAL_COUNTERPARTY_ID: 'deal.counterpartyId',
  DEAL_SETTLEMENT_VENUE: 'deal.settlementVenue',
  DEAL_CSD: 'deal.settlement',
  DEAL_SPONSOR_ID: 'deal.sponsorId',
  DEAL_BOND_PRICE: 'deal.bondPrice',
  DEAL_ACCRUED_INTEREST: 'deal.accruedInterest',
  DEAL_CALLABLE: 'deal.callableType',
  DEAL_CALL_DAYS: 'deal.callablePeriodDays',
  DEAL_STRATEGY: 'deal.strategy',
  DEAL_INITIATOR_PRIME_BROKER_ID: 'deal.initiatorPrimeBrokerId',
  DEAL_BOOK: 'deal.book',
  DEAL_INITIATOR_BOOK: 'deal.initiatorBook',
  DEAL_INITIATOR_STRATEGY: 'deal.initiatorStrategy',
  DEAL_RESPONDER_BOOK: 'deal.responderBook',
  DEAL_RESPONDER_STRATEGY: 'deal.responderStrategy',
  DEAL_BUNDLE: 'deal.bundle',
  DEAL_ID: 'deal.dealId',
  DEAL_ORDER_ID: 'deal.orderId',
  DEAL_NEGOTIATION_ID: 'deal.negotiationId',
  DEAL_UTI: 'deal.uti',
  DEAL_ORIGINATOR: 'deal.createdBy',
  DEAL_INITIATOR_INVESTMENT_DECISION_MAKER: 'deal.initiatorInvestmentDecisionMaker',
  DEAL_INITIATOR_EXECUTION_DECISION_MAKER: 'deal.initiatorExecutionDecisionMaker',
  DEAL_RESPONDER_INVESTMENT_DECISION_MAKER: 'deal.responderInvestmentDecisionMaker',
  DEAL_RESPONDER_EXECUTION_DECISION_MAKER: 'deal.responderExecutionDecisionMaker',
  DEAL_RFQ_CREATED_AT: 'deal.createdAt',
  DEAL_TRADE_DATE: 'deal.tradeInstant',
  DEAL_TRADE_TIMESTAMP: 'deal.tradeInstant',
  DEAL_UPDATED_AT: 'deal.lastUpdatedAt',
  DEAL_UPDATED_BY: 'deal.lastUpdatedBy'
}
